import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import { db } from "../firebase";
import logo from "../images/logo.png";

export class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      employeId: "",
      error: "",
      userExist: false,
      isRegistrationComplete: true,
      isRegistered: true,
      isloggedIn: false,
    };
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value.replace(/\s/g, ""),
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    // Check for both email and employeId filled
    if (this.state.email && this.state.employeId) {
      // Check  for SAP email
      const re = RegExp(/^[A-Za-z0-9._%+-]+@sap.com$/);
      if (!re.test(this.state.email)) {
        this.setState({ error: "Please enter your registered SAP email" });
      } else {
        // SAP mail present
        const docname = String(this.state.email).toLowerCase();
        var doc;
        try {
          // Check if Internet present and get value correctly
          const ref = db.collection("users").doc(docname);
          doc = await ref.get();

          if (doc.exists) {
            const user = doc.data();
            // Check if REgistration Complete
            // Check EmployeeId true for the user
            if (
              String(user.employeId).toLowerCase() ===
              String(this.state.employeId).toLowerCase()
            ) {
              // Every thing fine. redirect to the place
              // this.setState({ isloggedIn: true });
              window.location.href = "/sapworld.html";
            } else {
              this.setState({
                error: "Employee ID doesn't match for the " + this.state.email,
              });
            }
          } else {
            this.setState({
              error:
                "OOPS! You are not registered. Please register first using your SAP email.",
              isRegistered: false,
            });
          }
        } catch (error) {
          this.setState({
            error: "Looks like something went wrong. Please refresh",
          });
        }
      }
    } else {
      this.state.setState({ error: "Both fields mandatory. Kindly fill" });
    }
  };

  handleGoToRegister = () => {
    window.location.href = "/register";
  };

  render() {
    var loginRegisterButton;
    if (this.state.isRegistered) {
      if (this.state.isRegistrationComplete) {
        loginRegisterButton = (
          <input
            type="submit"
            className="register-btn text-uppercase"
            value="SUBMIT"
          />
        );
      } else {
        loginRegisterButton = (
          <input
            type="button"
            className="register-btn text-uppercase"
            value="GO TO REGISTER"
            onClick={this.handleGoToRegister}
          />
        );
      }
    } else {
      loginRegisterButton = (
        <input
          type="button"
          className="register-btn text-uppercase"
          value="GO TO REGISTER"
          onClick={this.handleGoToRegister}
        />
      );
    }
    return (
      <div className="cmn-bg">
        {this.state.isloggedIn ? <Redirect to="/game"></Redirect> : null}
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="text-center">
                <Link to="/">
                  <img src={logo} alt="logo" className="logo" />
                </Link>

                <form className="reg-form" onSubmit={this.handleSubmit}>
                  {this.state.error ? (
                    <p style={{ color: "red" }}>{this.state.error}</p>
                  ) : null}
                  <h2 className="text-uppercase">LOGIN</h2>
                  <div className="row align-items-center my-2">
                    <label className="col-sm-3 text-white">Email ID:</label>
                    <div className="col-sm-9">
                      <input
                        type="email"
                        className="textbox"
                        name="email"
                        value={this.state.email}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="row align-items-center my-2">
                    <label className="col-sm-3 text-white">Employee ID:</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="textbox"
                        name="employeId"
                        onChange={this.handleChange}
                        value={this.state.employeId}
                        required
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 my-2">{loginRegisterButton}</div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;
